import {
  FormField,
  FormGrid,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useForm } from 'react-hook-form';

import { whatsAppTwilioApi } from 'apis/whatsAppTwilio';
import { HookFormQueuesSelect } from 'components/hookForm';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';

import styles from './whatsAppEditPhoneNumberQueueModal.module.scss';

type FieldValues = {
  queueId: string[];
};

const formId = 'whatsapp-edit-phone-number-queue-modal';

/** Represents the modal for editing the queue of a WhatsApp number. */
export const WhatsAppEditPhoneNumberQueueModal = createAppModal(
  { type: 'settings:whatsAppEditPhoneNumberQueue' },
  ({ isOpen, modal, hide }): JSX.Element => {
    const notify = useNotifications();

    const [updateQueue, { isLoading }] =
      whatsAppTwilioApi.useUpdateWhatsAppPhoneNumberQueueMutation();

    const { phoneNumber } = modal.arg;

    const form = useForm<FieldValues>({
      mode: 'all',
      defaultValues: {
        queueId: [phoneNumber.default_queue_id],
      },
    });

    const handleSubmit = async (values: FieldValues) => {
      try {
        await updateQueue({
          phoneNumberId: phoneNumber.id,
          queueId: values.queueId[0],
        }).unwrap();

        notify(
          {
            title: 'Queue successfully updated.',
            time: 3000,
          },
          NotificationType.Success,
        );

        hide?.();
      } catch {
        notify(
          {
            title: 'An error occurred while updating the queue.',
          },
          NotificationType.Error,
        );
      }
    };

    return (
      <Modal isOpen={isOpen} onClose={hide} className={styles.modal}>
        <ModalHead title="Edit WhatsApp phone number queue" onClose={hide} />

        <ModalBody>
          <form
            id={formId}
            noValidate
            onSubmit={form.handleSubmit(handleSubmit)}
          >
            <FormGrid>
              <FormField>
                <HookFormQueuesSelect
                  name="queueId"
                  label="Queue for incoming conversations"
                  control={form.control}
                  rules={{
                    required: 'Queue is required',
                  }}
                  noAlert
                />
              </FormField>
            </FormGrid>
          </form>
        </ModalBody>

        <ModalFoot
          cancelOnClick={hide}
          confirmName="Update"
          confirmOnClick={noop}
          confirmProps={{
            type: 'submit',
            isLoading,
            disabled: !form.formState.isValid || form.formState.isSubmitting,
            form: formId,
          }}
        />
      </Modal>
    );
  },
);
